import axios from 'axios'

export const createExport = body =>
  axios.post(`/api/exports`, body).then(({ data }) => data)

export const fetchExport = id =>
  axios.get(`/api/exports/${id}`).then(({ data }) => data)
